import React, { useState } from "react";

const HoverFullText = ({ text, className = "", sliceLength = 12 }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleClick = () => {
        navigator.clipboard?.writeText(text); // copy to clipboard
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // hide after 2s
    };

    return (
        <div
            className={`relative cursor-pointer ${className}`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={handleClick}
        >
            {/* Display sliced text */}
            <span>{text?.length > sliceLength ? text.slice(0, sliceLength) + "..." : text}</span>

            {/* Hover tooltip for full content */}
            {showTooltip && (
                <div className="absolute left-0 bottom-full mb-1 z-50 w-max max-w-[25vmax] bg-gray-800 text-white
         text-xs p-1 rounded shadow-lg break-words">
                    {copied ? "Copied!" :  text }
                </div>
            )}
        </div>
    );
};

export default HoverFullText;
